module.exports = __webpack_public_path__ + "img/img-3.a46fdd63.jpeg";